import { brandProductTypesEnum } from 'root/src/shared/constants/dropEvent'
import prop from 'ramda/src/prop'
import { camelCaseSpace } from 'root/src/shared/util/stringCase'
import { readablePlatformsMap, readableKeyTypesMap } from 'root/src/shared/constants/dropKeys'

const typePartMap = {
	[brandProductTypesEnum.customProduct]: ' for viewers',
	[brandProductTypesEnum.dropKey]: ' for viewers',
	[brandProductTypesEnum.dropCode]: ' for viewers',
	[brandProductTypesEnum.placeholder]: '',
}

export const getFullKeyName = (
	{ game, keyType, region, platform },
) => `${prop('name', game)} ${readablePlatformsMap[platform]} ${camelCaseSpace(region)} ${readableKeyTypesMap[keyType]} Key`

export default (
	{ amount, name, type }, forViewers = false,
) => `${amount ? `(${amount}) ` : ''}${name}${forViewers ? typePartMap[type] : ''}`
